<!-- section template -->
<template>
  <div id="app" v-loading.fullscreen="isTryToFecthLoading" element-loading-background="rgba(255, 255, 255, 0.6)"
    :class="appClass" :style="appVr">
    <component :is="$globalIsTouchDevice ? 'div' : 'el-scrollbar'" id="scrollBar" ref="scrollBar" wrap-class="list"
      view-class="view-box" :native="false" style="height: 100%;">
      <RouterView :key="$route.fullPath" />
    </component>
    <ToolSocialLine v-if="(!!currentMerchant.lineId || !!currentMerchant.lineFriendUrl) && !$globalIsLiffClient" />
    <ToolPrepaid
      v-if="$globalWindowWidth > 767 && $route.name && $route.name !== 'prepaid-reservation' && $globalIsJtailsMode && isSiteEnabled && hasPrepaid" />
    <ToolReservation v-if="$globalIsDingBeauty && isSiteEnabled" title="立即預約" />
  </div>
</template>


<script>
import { authComputed, merchantComputed } from '@store/helpers'
import _throttle from "lodash/throttle";
import store from '@store';
import getScrollTop from "@utils/get-scroll-top";
import liff from "@line/liff";
import { autoOpenGlobalDialog } from "@plugins/global-dialog";
import parseISO from "date-fns/parseISO";

export default {
  page: {
    titleTemplate(title) {
      const merchant = store.state.merchant.currentMerchant || '';

      title = typeof title === 'function'
        ? title(this.$store)
        : title;
      return title
        ? `${merchant.title} | ${title} | ${this.$t('site.CONFIG_TITLE')}`
        : `${merchant.title} | ${this.$t('site.CONFIG_TITLE')}`
    },
  },
  name: 'App',
  components: {
    ToolSocialLine: () => import("@components/Tool/ToolSocialLine"),
    ToolPrepaid: () => import("@components/Tool/ToolPrepaid"),
    ToolReservation: () => import("@components/Tool/ToolReservation"),
  },
  data() {
    return {
      varVh: 0,
      isToolIn: true,
      isExpireddLevelTimer: null,
      levelBetweenTime: 0,
      isTryToFecthLoading: false,
      isMemberLevelExpired: false,
    }
  },
  computed: {
    ...authComputed,
    ...merchantComputed,
    appClass() {
      return [
        this.currentMerchant.alias,
        {
          isDevelopment: this.$globalIsDevelopment,
          isHambugerOpen: this.$globalHambugerOpen,
          isToolIn: this.isToolIn,
          isTouchDevice: this.$globalIsTouchDevice,
          isCustomChatHidden: this.$globalIsLiffClient,
          isShowHeader: !this.$globalIsLiffClient || this.$route.meta.liffShowMenu !== false
        }
      ]
    },
    appVr() {
      return {
        '--vh': `${this.varVh}px`,
        '--color-blue': this.$globalDarkTheme
          ? '#000'
          : '#D9F0F8',
        '--color-blue-dark': this.$globalDarkTheme
          ? '#FFF'
          : '#1B2B55',
        '--img-pattern-1': this.$globalDarkTheme
          ? `url('${require('@assets/images/home/pattern-1-dark.svg')}')`
          : `url('${require('@assets/images/home/pattern-1.svg')}')`
      }
    },
    hasPrepaid() {
      return !!this.$store.state.merchant.currentMerchant.prepaidSetting.isEnabled
    },
  },
  watch: {
    $route() {
      if (this.$route.meta.isScrollRestoration !== true && !this.$route.query.section) {
        if (!this.$globalIsTouchDevice) {
          this.$refs['scrollBar'].wrap.scrollTop = 0
        }
      }

      this.$globalHambugerOpen = false;

      this.autoSrcollToSection();
    },

  },
  mounted() {
    const initScrollListener = () => {
      if (this.$globalIsTouchDevice) {
        window.addEventListener('scroll', this.onScroll);
      } else {
        this.$refs['scrollBar'].wrap.addEventListener('scroll', this.onScroll);
      }
    };

    const initResizeListener = () => {
      const setVarVh = () => {
        this.varVh = window.innerHeight * 0.01
      };

      const setBreakpoint = () => {
        const windowWidth = document.body.clientWidth;

        if (windowWidth > 1920) {
          this.$globalBreakpoint = '2xl'
        } else if (windowWidth > 1500) {
          this.$globalBreakpoint = 'xl'
        } else if (windowWidth > 992) {
          this.$globalBreakpoint = 'lg'
        } else if (windowWidth < 768) {
          this.$globalBreakpoint = 'md'
        } else if (windowWidth < 576) {
          this.$globalBreakpoint = 'sm'
        } else if (windowWidth > 322) {
          this.$globalBreakpoint = '2sm'
        } else {
          this.$globalBreakpoint = 'xs'
        }
      };

      const setGlobalWindowWidth = () => {
        this.$globalWindowWidth = document.body.clientWidth;
      };

      setVarVh();
      setBreakpoint();
      setGlobalWindowWidth();

      window.addEventListener('resize', () => {
        setVarVh();
        setBreakpoint();
        setGlobalWindowWidth();
      });
    };

    const initIsToolIn = () => {
      setTimeout(() => {
        this.isToolIn = true
      }, 600 /* 最少600 */)
    };

    const initLocalStorageListener = () => {
      window.onstorage = (e) => {
        const authKey = 'site.auth.currentMember';
        if (e.key === authKey) {
          const newValue = JSON.parse(e.newValue);

          this.$store.dispatch('auth/setCurrentUser', newValue);

          const checkIsLoginPage = () => {
            if (this.$route.meta.isLoginPage) {
              if (!this.isLoggedIn) {
                this.$router.push({
                  name: 'login',
                  query: {
                    redirectFrom: location.pathname
                  },
                })
              }
            }
          };

          const checkIsLogoutPage = () => {
            if (this.$route.meta.isLogoutPage) {
              if (this.isLoggedIn) {
                window.location = this.$route.query.redirectFrom || '/member'
              }
            }
          };




          checkIsLogoutPage();
          checkIsLoginPage();
        }
      }
    };

    const initLiff = () => {
      if (!liff.isInClient && this.currentLiffId) {
        liff.init({
          liffId: this.currentLiffId
        })
          .catch(() => {
            store.dispatch('auth/setCurrentLiffId', null)
          });
      }
    };
    const initCheckMemberLevelTimer = () => {
      this.isExpireddLevelTimer = setInterval(() => {
        this.checkExpired();
      }, 5000)
    };

    initCheckMemberLevelTimer();

    this.autoSrcollToSection();
    initScrollListener();
    initResizeListener();
    initIsToolIn();
    initLocalStorageListener();
    initLiff();
    autoOpenGlobalDialog();
  },
  destroyed() {
    const clearCheckIsLevelExpiredTimer = () => {
      clearInterval(this.isExpireddLevelTimer);
    };

    clearCheckIsLevelExpiredTimer();
  },
  methods: {
    onScroll: _throttle(function () {
      const scrollTop = this.$globalIsTouchDevice
        ? getScrollTop()
        : this.$refs['scrollBar'].wrap.scrollTop;

      if (scrollTop > this.$globalScrollTop) {
        this.$globalDirection = 'down'
      } else {
        this.$globalDirection = 'up'
      }

      this.$globalScrollTop = scrollTop
    }, 200),
    autoSrcollToSection() {
      const timer = setInterval(() => {
        scrollTo();
      }, 100);

      setTimeout(() => {
        clearInterval(timer)
      }, 1000);

      const scrollTo = () => {
        const sectionId = this.$route.query.section;

        if (sectionId && document.getElementById(sectionId || '')) {
          this.$scrollToElement({
            $el: document.getElementById(sectionId || ''),
            offset: 100,
          });

          setTimeout(() => {
            clearInterval(timer)
          }, 300)
        }
      };
    },
    checkExpired() {
      if (this.currentMember?.level?.expiredAt) {
        const isExpired = new Date >= new Date(this.currentMember?.level?.expiredAt)
        if (isExpired) {
          if (!this.isMemberLevelExpired) {
            this.$alert(`您目前的會員等級"${this.currentMember.level.title}"已截止`, {
              title: `提示`,
              showClose: false,
              dangerouslyUseHTMLString: true
            })
              .then(() => {
                this.tryToFetchMemberInfo()
              });
          }
          this.isMemberLevelExpired = true

        }
      }
    },
    async tryToFetchMemberInfo() {
      this.isTryToFecthLoading = true
      await this.$store.dispatch('auth/fetchMember').then(() => {
        this.isTryToFecthLoading = false
        this.isMemberLevelExpired = false
      })
    },
  }
}
</script>


